export default __webpack_public_path__ + "static/PrivacyPolicy_DE-94b30daaa1f86d729b0d7572ab8d5561.pdf";